<template lang="pug">
.page-article-imgs
  .text-body-1.font-weight-bold {{ title }}
  v-divider.mb-3
  lingallery.mb-6(:height="height", :items="items_")
</template>

<script>
import Lingallery from "lingallery";

const _config = {
  title: "Imagens",
};

export default {
  data: () => ({ ..._config, height: 400 }),
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    items_() {
      return this.items.map((v) => ({
        src: this.files + v + "?resize=1&w=800",
        thumbnail: this.files + v + "?resize=1&w=80",
      }));
    },
  },
  components: {
    Lingallery,
  },
};
</script>

<style>
.page-article-imgs .lingallery figure {
  background: #0000001c;
}
.page-article-imgs .lingallery figure img {
  width: 100%;
  object-fit: contain;
}
</style>
